import styled from "styled-components";
import {JackpotWidgetAmountLabelDefaultBox} from "./jackpot-widget-amount-label.default.box";

export const JackpotWidgetAmountLabelMrGreenBox = styled(JackpotWidgetAmountLabelDefaultBox)`
    color: ${({theme}) => theme.colors.textDark };
    text-transform: capitalize;
    text-shadow: 0px 2.70px 2.70px rgba(0, 0, 0, 0.29);
`;
